import React, { useState } from 'react';
import { X } from 'lucide-react';
import './BuyBoxModal.css';

const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const CcEmailsInput = ({
    value = [],
    onChange,
    disabled = false,
    maxEmails = 10,
    placeholder = 'client@example.com',
    label = 'CC Emails',
    inputClassName = 'std-input',
    addButtonClassName = 'cc-add-btn',
}) => {
    const [ccInput, setCcInput] = useState('');
    const [ccError, setCcError] = useState('');

    const handleAdd = () => {
        const email = ccInput.trim().toLowerCase();
        if (!email) return;
        setCcError('');
        if (!EMAIL_RE.test(email)) {
            setCcError('Please enter a valid email address.');
            return;
        }
        if (value.includes(email)) {
            setCcError('This email is already added.');
            return;
        }
        if (value.length >= maxEmails) {
            setCcError(`Maximum ${maxEmails} CC emails allowed.`);
            return;
        }
        onChange([...value, email]);
        setCcInput('');
    };

    const handleRemove = (email) => {
        onChange(value.filter(e => e !== email));
        setCcError('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            handleAdd();
        }
    };

    return (
        <>
            {label && <label className="form-label">{label}</label>}
            <div className="cc-input-row">
                <input
                    type="email"
                    className={inputClassName}
                    placeholder={placeholder}
                    value={ccInput}
                    onChange={(e) => { setCcInput(e.target.value); setCcError(''); }}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                />
                <button
                    type="button"
                    className={addButtonClassName}
                    onClick={handleAdd}
                    disabled={disabled}
                >
                    Add
                </button>
            </div>
            {ccError && <p className="cc-error">{ccError}</p>}
            {value.length > 0 && (
                <div className="cc-chips" style={{ marginTop: 8 }}>
                    {value.map(email => (
                        <span key={email} className="cc-chip">
                            {email}
                            <button
                                type="button"
                                className="cc-chip-remove"
                                onClick={() => handleRemove(email)}
                                disabled={disabled}
                            >
                                <X size={12} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
        </>
    );
};

export default CcEmailsInput;
